module.exports = __webpack_public_path__ + "img/Icon-In.9ebe3916.png";